<template>
  <div class="variant-info">
    <TooltipPlugin v-if="contentIsLong" :tooltipText="content">
      <template #tooltip-btn>
        <Label :content="(content.slice(0, 15) + '...')" />
      </template>
    </TooltipPlugin>

    <Label v-else :content="content" />
    <img
      v-if="imgUrl"
      :src="imgUrl"
      alt="variant_image"
      class="variant-image"
    />
    <TableHeadTooltip
      v-if="imgUrl"
      :tooltipTrigger="tooltipTrigger"
      :tooltipImage="imgUrl"
      :position="tooltipPosition"
      :tooltipWidth="tooltipWidth"
      :showArrow="showArrow"
      :offsetTooltipImage="offsetTooltipImage"
    />
  </div>
</template>

<script>
import Label from './Label.vue';
import TableHeadTooltip from './TableHeadTooltip.vue';
import { TooltipPlugin } from '@n11/so-ui-components';

export default {
  name: 'VariantCell',
  components: {
    Label,
    TableHeadTooltip,
    TooltipPlugin,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    imgUrl: {
      type: String,
      required: false,
      default: null,
    },
    tooltipTrigger: {
      type: String,
      default: 'hover',
    },
    tooltipPosition: {
      type: String,
      default: 'right',
    },
    tooltipWidth: {
      type: Number,
      default: 0,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    offsetTooltipImage: {
      type: Array,
      default: () => [0, 14],
    },
  },
  computed: {
    contentIsLong() {
      return this.content.length > 15;
    }
  }
};

</script>

<style scoped lang="scss">
@import '../../assets/styles/variables.scss';
.variant-info {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-left: 8px;
  padding-right: 20px;
  max-width: 164px;
  label{
    white-space: nowrap;
  }
  .variant-image{
    width: 26px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 4px;
    border: 0.5px solid $colorN50;
    /* &:hover{
      border: 0.5px solid $colorM50;
    } */
  }
}

</style>

